module.exports = __webpack_public_path__ + "static/media/1.e7a13e39.jpg";